import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {wineRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  nameText: {
    fontFamily: 'Open Sans',
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 24,
    color: '#3D3D3D',
    flexShrink: 1,
  },
  nameWarningWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    flexShrink: 1,
  },
  alertButtonIcon: {
    fontSize: 18,
    fontWeight: '700',
    color: wineRed,
    marginLeft: indent * 0.5,
    alignSelf: 'center',
  },
});
